import React, { createContext, useContext, useState, ReactNode } from "react";

interface ConfirmationContextType {
  showConfirmation: (props: ConfirmationProps) => void;
  hideConfirmation: () => void;
  confirmationProps: ConfirmationProps | null;
}

interface ConfirmationProps {
  onConfirm: () => void;
  description: string;
  title?: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationContext = createContext<ConfirmationContextType | undefined>(
  undefined
);

export function ConfirmationProvider({ children }: { children: ReactNode }) {
  const [confirmationProps, setConfirmationProps] =
    useState<ConfirmationProps | null>(null);

  const showConfirmation = (props: ConfirmationProps) => {
    setConfirmationProps(props);
  };

  const hideConfirmation = () => {
    setConfirmationProps(null);
  };

  return (
    <ConfirmationContext.Provider
      value={{
        showConfirmation,
        hideConfirmation,
        confirmationProps,
      }}
    >
      {children}
    </ConfirmationContext.Provider>
  );
}

export function useConfirmation() {
  const context = useContext(ConfirmationContext);
  if (context === undefined) {
    throw new Error(
      "useConfirmation must be used within a ConfirmationProvider"
    );
  }
  return context;
}
